import View from './view';
import {useSelector} from 'react-redux';
import {contentSelector} from '../../../../../redux/selectors/resources';
import {Props} from './model';
export const Copywrite = (props: Props) => {
  const content = useSelector(contentSelector());
  return View({
    ...props,
    content,
  });
};
